// Enums for passing layout to render to child components
//   DESK: Desktop, TAB: Tablet, MOB: Mobile
export const LAYOUT = Object.freeze({ DESK: 1, TAB: 2, MOB: 3 });
// Enums to control the minimum width at which a particular layout renders
export const MIN_WIDTH = Object.freeze({ DESK: 871, TAB: 480, MOB: 0 });



// WEBPACK FOOTER //
// ./src/components/Layout/enums.js